import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Button,
  TextArea,
  Table,
  Accordion,
  AccordionItem,
} from '@carbon/react';
import {
  getAsessmentInfoByUUID,
  upsertIndvAssSectionResponses,
} from '../../../actions/PscPeerFeedback';
import Dropdown from '../../../components/common/Dropdown';
import JDProcessOverlay from '../../../components/common/JDProcessOverlay';
import _ from 'lodash';
import './PscPeerFeedback.css';
import { ChevronDownOutline, ChevronUpOutline } from '@carbon/icons-react';
import { motion, AnimatePresence } from 'framer-motion';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { toast } from 'react-toastify';
import { lowerAndTrim } from '../../../utils/helpers';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';

const serverBusyMessage =
  'Unable to process the request, please try again. If the issue persists, please contact support@x0pa.com';

const marks = Array.from({ length: 7 }, (_, i) => ({
  value: i,
  label: i.toString(),
}));

const renderHtml = (htmlObject) => {
  return (
    <div
      className="html-render-content"
      dangerouslySetInnerHTML={{ __html: htmlObject }}
    />
  );
};

class PscPeerFeedbackAssessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 1,
      isVertical: window.innerWidth <= 1024, // Set initial orientation based on window size
      selectedCandidates: {},
      areAllInputsValid: true,
      sectionThreeRecords: [],
    };
  }

  moveCard = (index, direction) => {
    const { cards } = this.state;
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= cards.length) return;

    const newCards = [...cards];
    [newCards[index], newCards[newIndex]] = [
      newCards[newIndex],
      newCards[index],
    ];

    this.setState({ cards: newCards });
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleGetAssessmentInfo();
    this.props.setHasFixedBottom?.(true);
  }

  componentDidUpdate(prevProps) {
    const { match } = prevProps || {};
    const {
      params: { candidateId: prevCandidateId, sectionKey: prevSectionKey } = {},
    } = match || {};
    const { match: { params: { candidateId, sectionKey } = {} } = {} } =
      this.props;

    if (prevCandidateId !== candidateId || prevSectionKey !== sectionKey) {
      this.handleGetAssessmentInfo(); // re-fetch data for the new candidate
      this.props.setHasFixedBottom?.(true);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.props.setHasFixedBottom?.(false);
  }

  fetchFromLocalStorage = () => {
    const { match: { params: { id, candidateId, sectionKey } = {} } = {} } =
      this.props;
    return JSON.parse(
      localStorage.getItem(`${id}-${candidateId}-${sectionKey}`)
    );
  };

  saveToLocalStorage = (updateObj) => {
    const { match: { params: { id, candidateId, sectionKey } = {} } = {} } =
      this.props;
    const { data: localDataRaw = {} } = this.fetchFromLocalStorage() || {};

    const data = { ...localDataRaw, ...updateObj };
    const finalData = {
      data,
    };
    localStorage.setItem(
      `${id}-${candidateId}-${sectionKey}`,
      JSON.stringify(finalData)
    );
  };

  removeFromLocalStorage = () => {
    const { match: { params: { id, candidateId, sectionKey } = {} } = {} } =
      this.props;
    localStorage.removeItem(`${id}-${candidateId}-${sectionKey}`);
  };

  handleResize = () => {
    this.setState({ isVertical: window.innerWidth <= 1024 });
  };

  populateDataFromGetAPI = (currentSection = {}) => {
    const {
      history,
      match: { params: { sectionKey, id, candidateId } = {} } = {},
    } = this.props;

    const {
      questions = [],
      peerList = [],
      responses = [],
    } = currentSection || {};

    const currSectionInfo = this.fetchFromLocalStorage();
    const { data: localDataRaw = {} } = currSectionInfo || {};

    let currCandResponses = [];

    if (sectionKey === '1' || sectionKey === '2') {
      currCandResponses = _.values(
        peerList?.find((itm) => itm?.candidateId == candidateId)?.responses
      );
    } else if (sectionKey === '3') {
      currCandResponses = responses;
    }

    const updateStateObj = {};

    if (sectionKey === '1' || sectionKey === '2') {
      const responseMap =
        currCandResponses &&
        Array.isArray(currCandResponses) &&
        currCandResponses.length > 0 &&
        Object.fromEntries(
          currCandResponses.map((resp) => [resp.questionId, resp])
        );
      if (questions && Array.isArray(questions) && questions.length > 0) {
        questions.forEach((itm) => {
          if (sectionKey === '1' || sectionKey === '2') {
            updateStateObj[`rating-${itm?.questionId}`] =
              responseMap?.[itm?.questionId]?.value ??
              localDataRaw?.[`rating-${itm?.questionId}`];
          }
        });
      }
    } else if (sectionKey === '3') {
      const choices = questions?.[0]?.value?.choices || [];
      updateStateObj[`selectedCandidates`] = {};
      if (choices && Array.isArray(choices) && choices.length > 0) {
        choices.forEach((itm) => {
          const currRespObj = currCandResponses?.find(
            (candResp) => candResp?.evaluatedCandidateId == itm?.candidateId
          );

          const { comments, evaluatedCandidateFullName, evaluatedCandidateId } =
            currRespObj || {};

          const { selectedCandidates } = localDataRaw || {};

          const peerCandObj =
            (evaluatedCandidateId
              ? {
                  label: evaluatedCandidateFullName,
                  value: evaluatedCandidateId,
                }
              : selectedCandidates?.[`peer-cand-name-${itm?.candidateId}`]) ||
            {};

          updateStateObj[`peer-cand-name-${itm?.candidateId}`] = peerCandObj;

          updateStateObj[`comment-${itm?.candidateId}`] =
            comments ?? (localDataRaw?.[`comment-${itm?.candidateId}`] || '');

          updateStateObj['selectedCandidates'][
            `peer-cand-name-${itm?.candidateId}`
          ] = peerCandObj;
        });
      }
    } else if (sectionKey === '4') {
      if (responses && Array.isArray(responses) && responses.length > 0) {
        const { comments, evaluatedCandidateFullName, evaluatedCandidateId } =
          responses?.[0] || {};

        const peerCandObj =
          (evaluatedCandidateId
            ? {
                label:
                  evaluatedCandidateId == 0
                    ? 'None'
                    : evaluatedCandidateFullName,
                value: evaluatedCandidateId,
              }
            : localDataRaw?.peerCand) || {};

        updateStateObj.peerCand = peerCandObj;
        updateStateObj.comments = comments ?? localDataRaw?.comments;
      }
    }

    this.setState({ ...updateStateObj });
  };

  populateDataFromLocalStorage = (localDataRaw = {}) => {
    this.setState({ ...localDataRaw });
  };

  handleGetAssessmentInfo = () => {
    const { match: { params: { id, sectionKey } = {} } = {} } = this.props;
    this.props
      .getAsessmentInfoByUUID(id)
      .then((res) => {
        if (res && !res.error) {
          const { sections, candidateInfo, draftedAt } = res || {};
          const currentSection = sections?.[sectionKey] || {};
          const {
            headers = [],
            questions = [],
            peerList = [],
            responses = [],
          } = currentSection || {};

          const updateStateObj = {
            headers,
            questions,
            peerList,
            candidateInfo,
          };

          if (sectionKey === '3') {
            const choices = questions?.[0]?.value?.choices || [];
            const renderedChoices = Array(choices.length).fill(null);

            responses.forEach(({ evaluatedCandidateId, rank }) => {
              const candidate = choices.find(
                (choice) => choice.candidateId == evaluatedCandidateId
              );
              if (candidate) {
                renderedChoices[rank - 1] = candidate; // Place candidate at index based on rank
              }
            });

            // Fill remaining gaps with unranked choices
            choices.forEach((choice) => {
              if (
                !renderedChoices.some(
                  (rendered) =>
                    rendered && rendered.candidateId === choice.candidateId
                )
              ) {
                const firstEmptyIndex = renderedChoices.findIndex(
                  (rendered) => rendered === null
                );
                if (firstEmptyIndex !== -1) {
                  renderedChoices[firstEmptyIndex] = choice;
                }
              }
            });

            updateStateObj.sectionThreeRecords =
              renderedChoices.filter(Boolean); // Remove null entries
          }

          this.setState(updateStateObj);

          this.populateDataFromGetAPI(currentSection);
        } else {
          toast.error(res?.error?.message || serverBusyMessage);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(err?.message || serverBusyMessage);
      });
  };

  handleChange = (name, value) => {
    const updateObj = { [`${name}`]: value };
    this.setState({ ...updateObj });
    this.saveToLocalStorage(updateObj);
  };

  validateInputs = () => {
    const {
      history,
      match: { params: { sectionKey, id, candidateId } = {} } = {},
    } = this.props;
    const { questions, sectionThreeRecords, peerCand, comments } = this.state;

    const invalidResponses = {};

    if (sectionKey === '1' || sectionKey === '2') {
      questions.forEach((element, idx) => {
        const { questionId } = element || {};
        invalidResponses[`rating-${questionId}`] =
          !this.state[`rating-${questionId}`] ||
          this.state[`rating-${questionId}`] == 0;
      });
    } else if (sectionKey === '3') {
      sectionThreeRecords.forEach((element, idx) => {
        const { candidateId: candId } = element || {};
        invalidResponses[`peer-cand-name-${candId}`] =
          !this.state[`peer-cand-name-${candId}`]?.value;
        invalidResponses[`comment-${candId}`] =
          !this.state[`comment-${candId}`] ||
          lowerAndTrim(this.state[`comment-${candId}`]).length <= 0;
      });
    } else if (sectionKey === '4') {
      invalidResponses['peerCand'] = !peerCand?.value;
      if (
        peerCand?.value &&
        peerCand?.value !== '0' &&
        (!comments || lowerAndTrim(comments).length <= 0)
      )
        invalidResponses['comments'] = true;
    }

    const areAllInputsValid = !Object.values(invalidResponses).some(Boolean);

    this.setState({ invalidResponses, areAllInputsValid });

    if (!areAllInputsValid)
      toast.error('Please check if all the input fields are filled.');

    return areAllInputsValid;
  };

  handleSubmit = (saveAsDraft) => {
    const {
      history,
      match: { params: { sectionKey, id, candidateId } = {} } = {},
    } = this.props;
    const {
      questions,
      candidateInfo,
      sectionThreeRecords,
      peerCand,
      peerList = [],
    } = this.state;

    const areAllInputsValid = saveAsDraft ? true : this.validateInputs();

    if (!areAllInputsValid) return;

    const data = {
      publicId: id,
      sectionNo: sectionKey && Number(sectionKey),
      status: saveAsDraft ? 'Draft' : 'Completed',
    };

    if (sectionKey === '1' || sectionKey === '2') {
      const responses = [];
      questions.forEach((element, idx) => {
        const { questionId, orderNo } = element || {};
        const obj = {
          questionId,
          orderNo,
        };

        obj.value = this.state[`rating-${questionId}`];
        data.evaluatedCandidateId =
          sectionKey === '2' ? candidateInfo?.candidateId : candidateId;

        responses.push(obj);
      });

      data.responses = responses;
    } else if (sectionKey === '3') {
      const responses = [];
      sectionThreeRecords.forEach((element, idx) => {
        const { orderNo, candidateId: candId } = element || {};
        const obj = {
          questionId: questions?.[0]?.questionId,
          orderNo,
        };

        obj.evaluatedCandidateId =
          this.state[`peer-cand-name-${candId}`]?.value ?? null;
        obj.rank = idx + 1;
        obj.comments = this.state[`comment-${candId}`];

        responses.push(obj);
      });

      data.responses = responses;
    } else if (sectionKey === '4') {
      data.questionId = questions?.[0]?.questionId;
      data.evaluatedCandidateId = peerCand?.value;
      if (peerCand?.value) data.comments = this.state.comments;
    }

    this.props
      .upsertIndvAssSectionResponses(data)
      .then((res) => {
        const { error, message } = res || {};
        if (res && !res.error) {
          if (saveAsDraft) {
            toast.success(message);
            this.removeFromLocalStorage();
          } else {
            if (sectionKey === '1') {
              const currentIndex =
                peerList &&
                Array.isArray(peerList) &&
                peerList?.findIndex((itm) => itm.candidateId == candidateId);
              const nextCandidateIndex = currentIndex + 1;
              const nextCandidate =
                nextCandidateIndex > 0 &&
                nextCandidateIndex < peerList?.length &&
                peerList?.[nextCandidateIndex];
              const nextCandidateId = nextCandidate?.candidateId || null;

              if (nextCandidateId) {
                toast.success(
                  'Response(s) submitted successfully! Moving to the next candidate for feedback...',
                  {
                    autoClose: 3000,
                    hideProgressBar: false,
                  }
                );

                setTimeout(() => {
                  history.push(
                    `/psc-peer-feedback/${id}/assessment/${nextCandidateId}/${sectionKey}`
                  );
                }, 3100); // wait for toast to finish
              } else {
                // Last candidate or no valid next, go back to assessment list page
                toast.success('Response(s) submitted successfully!');
                history.push(`/psc-peer-feedback/${id}/assessments`);
              }
            } else {
              toast.success('Response(s) submitted successfully!');
              history.push(`/psc-peer-feedback/${id}/assessments`);
            }
          }
        } else {
          toast.error(error?.message || serverBusyMessage);
        }
      })
      .catch((err) => {
        toast.error(err?.message || serverBusyMessage);
      });
  };

  handleDropdownChange = (metaValue, name) => {
    const { match: { params: { sectionKey } = {} } = {} } = this.props;
    this.setState((prevState) => {
      const updateObj = { [name]: metaValue };
      if (sectionKey === '3') {
        updateObj.selectedCandidates = {
          ...prevState.selectedCandidates,
          [name]: metaValue,
        };
      }
      if (name === 'peerCand' && metaValue?.value === '0')
        updateObj.comments = null;
      this.saveToLocalStorage(updateObj);
      return { ...updateObj };
    });
  };

  handleMoveRow = (index, direction) => {
    const { sectionThreeRecords } = this.state;
    const newSecThreeRecords = [...sectionThreeRecords];
    const swapIndex = index + direction;

    // Ensure index is within valid bounds
    if (swapIndex < 0 || swapIndex >= newSecThreeRecords.length) return;

    // Swap rows
    [newSecThreeRecords[index], newSecThreeRecords[swapIndex]] = [
      newSecThreeRecords[swapIndex],
      newSecThreeRecords[index],
    ];

    const updateObj = { sectionThreeRecords: newSecThreeRecords };
    this.setState({ ...updateObj });
    this.saveToLocalStorage(updateObj);
  };

  onDragEnd = (result) => {
    const { destination, source, reason } = result;
    const { sectionThreeRecords } = this.state;
    const entities = Object.assign([], sectionThreeRecords);
    const quote = sectionThreeRecords[source.index];
    entities.splice(source.index, 1);
    entities.splice(destination.index, 0, quote);
    this.setState({ sectionThreeRecords: entities });
  };

  render() {
    const {
      history,
      match: { params: { sectionKey, id, candidateId } = {} } = {},
    } = this.props;
    const { push } = history || {};
    const {
      isVertical,
      headers = [],
      questions = [],
      sectionThreeRecords,
      peerCand,
      peerList = [],
    } = this.state;

    const selectedValues = Object.values(this.state.selectedCandidates)
      ?.filter(Boolean)
      ?.map((i) => i?.value);

    const settings = {
      centerMode: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      //  allowArrows:  true
    };

    return (
      <div className="">
        <div className="mt-4">
          <div className="mb-2">
            <a
              className="xpa-link"
              href={`/psc-peer-feedback/${id}/assessments`}>
              &larr; Go Back
            </a>
          </div>

          <h6 className="h6 mt-3 mb-1 font-weight-bold">
            Candidate Name :{' '}
            {peerList?.find((itm) => itm?.candidateId == candidateId)
              ?.fullName ?? '-'}
          </h6>

          {_.map(headers, (value, key, idx) => {
            return (
              <div className="mb-3">
                <h6 className="h6 mb-1 font-weight-bold">
                  {value?.value?.title}
                </h6>
                <div>{renderHtml(value?.value?.value)}</div>
              </div>
            );
          })}

          <div className="mt-5">
            {(sectionKey === '1' || sectionKey === '2') && (
              <>
                {_.map(questions, (value, key, index) => {
                  const { sectionNo, questionId } = value || {};
                  const {
                    title,
                    ratings = [],
                    leftIndicators,
                    rightIndicators,
                  } = value?.value || {};
                  return (
                    <div className="mb-3 cds--tile">
                      <h5 className="mb-2">{title}</h5>
                      <div className="cds--row d-flex align-items-center">
                        <div className="cds--col-lg-6 cds--col-md-6 cds--col-sm-16 cds--col-xs-16 left-bg-color p-2 left-bg-color d-flex flex-column justify-content-center align-items-center">
                          <div>
                            <div
                              className="f-w-b ml-4"
                              style={{ fontSize: '1rem' }}>
                              Behavioural Indicators
                            </div>
                            {renderHtml(
                              isVertical ? rightIndicators : leftIndicators
                            )}
                          </div>
                        </div>

                        {/* Rating Slider (Centered) */}
                        <div
                          className={`cds--col-lg-4 cds--col-md-4 cds--col-sm-16 cds--col-xs-16 ${
                            isVertical ? 'my-3' : 'px-2'
                          }`}>
                          {/* <h3>Rating: {this.state[`rating-${questionId}`]}</h3> */}
                          <Box
                            sx={{
                              width: isVertical ? 60 : '100%', // Full width when horizontal
                              height: isVertical ? 200 : 60,
                              margin: 'auto',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              [`@media screen and (max-width: 1024px)`]: {
                                flexDirection: 'column',
                                width: 60,
                                height: 200,
                              },
                            }}>
                            <Slider
                              orientation={
                                isVertical ? 'vertical' : 'horizontal'
                              }
                              value={this.state[`rating-${questionId}`] ?? 0}
                              onChange={(e, val) =>
                                this.handleChange(`rating-${questionId}`, val)
                              }
                              step={1}
                              min={0}
                              max={6}
                              marks={marks}
                              sx={{
                                color: '#333',
                                '& .MuiSlider-track': {
                                  backgroundColor: '#333',
                                },
                                '& .MuiSlider-rail': {
                                  backgroundColor: '#ccc', // light gray for contrast
                                  opacity: 1,
                                },
                                '& .MuiSlider-thumb': {
                                  backgroundColor: '#333',
                                },
                              }}
                            />
                          </Box>
                        </div>

                        <div className="cds--col-lg-6 cds--col-md-6 cds--col-sm-16 cds--col-xs-16 p-2 d-flex flex-column justify-content-center align-items-center">
                          <div>
                            <div
                              className="f-w-b ml-4"
                              style={{ fontSize: '1rem' }}>
                              Behavioural Indicators
                            </div>
                            {renderHtml(
                              isVertical ? leftIndicators : rightIndicators
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {sectionKey === '3' && (
              <div>
                <div className="w-full max-w-sm mx-auto mt-6 space-y-4">
                  {sectionThreeRecords &&
                  Array.isArray(sectionThreeRecords) &&
                  sectionThreeRecords.length > 0 ? (
                    <AnimatePresence>
                      <Accordion className="css-gba-accr-z" align="start">
                        {sectionThreeRecords.map((itm, idx) => {
                          const { candidateId: candId } = itm || {};
                          const candidateName =
                            this.state[`peer-cand-name-${candId}`]?.label;
                          return (
                            <motion.div
                              key={candId}
                              layout
                              initial={{ opacity: 0, y: -10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: 10 }}
                              transition={{
                                type: 'spring',
                                stiffness: 300,
                                damping: 20,
                              }}
                              className="shadow-md rounded rounded-lg ">
                              <AccordionItem
                                className=""
                                title={
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="">
                                      <div className="cds--type-zeta">
                                        Rank #{idx + 1}{' '}
                                        {candidateName && `- ${candidateName}`}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center xpa-action-btns">
                                      <div className="d-flex">
                                        {idx > 0 && (
                                          <Button
                                            id={`up-arrow-${idx}`}
                                            kind="ghost"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this.handleMoveRow(idx, -1);
                                              document.activeElement.blur();
                                            }}
                                            size="small"
                                            hasIconOnly
                                            tooltipPosition="bottom"
                                            iconDescription="Move Up"
                                            className="p-0">
                                            <ChevronUpOutline />
                                          </Button>
                                        )}
                                        {idx <
                                          sectionThreeRecords.length - 1 && (
                                          <Button
                                            id={`down-arrow-${idx}`}
                                            kind="ghost"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this.handleMoveRow(idx, 1);
                                              document.activeElement.blur();
                                            }}
                                            size="small"
                                            hasIconOnly
                                            tooltipPosition="bottom"
                                            iconDescription="Move Down"
                                            className="p-0">
                                            <ChevronDownOutline />
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                }>
                                <>
                                  <div className="cds--row align-items-center mt-2">
                                    <div className="cds--col-md-2 cds--col-sm-3 cds--col-xs-3 cds--type-zeta">
                                      Peer Candidate Name{' '}
                                      <span className="text-danger">*</span>
                                    </div>
                                    <div className="cds--col-lg-12 cds--col-md-6 cds--col-sm-6 cds--col-xs-6">
                                      <Dropdown
                                        id={`peer-cand-name-${candId}`}
                                        title=""
                                        custom
                                        mainClassName="cds--form-item mb-0"
                                        className="w-100"
                                        // titleClass="mb-2"
                                        // labelClass="pt-2"
                                        onInputChange={() => {}}
                                        options={
                                          sectionThreeRecords
                                            ?.filter(
                                              (itm) =>
                                                !selectedValues.includes(
                                                  itm.candidateId
                                                ) ||
                                                this.state[
                                                  `peer-cand-name-${candId}`
                                                ] === itm.candidateId
                                            )
                                            ?.map((itm, idx) => {
                                              return {
                                                label: itm?.fullName,
                                                value: itm?.candidateId,
                                              };
                                            }) || []
                                        }
                                        name={`peer-cand-name-${candId}`}
                                        placeholder="Peer Candidate Name"
                                        onChange={(value, e, name) =>
                                          this.handleDropdownChange(e, name)
                                        }
                                        selectedValue={
                                          this.state[`peer-cand-name-${candId}`]
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="cds--row align-items-center mt-2">
                                    <div className="cds--col-md-2 cds--col-sm-3 cds--col-xs-3 cds--type-zeta">
                                      Comments{' '}
                                      <span className="text-danger">*</span>
                                    </div>
                                    <div className="cds--col-lg-12 cds--col-md-6 cds--col-sm-6 cds--col-xs-6">
                                      <TextArea
                                        className=""
                                        key={`comment-${candId}`}
                                        name={`comment-${candId}`}
                                        labelText=""
                                        hideLabel
                                        onChange={(e) =>
                                          this.handleChange(
                                            e?.target?.name,
                                            e?.target?.value
                                          )
                                        }
                                        placeholder="Type Here"
                                        // invalid={this.state[`valid-${ratingCriteriaId}`]}
                                        // invalidText="Please enter valid answer"
                                        id={`comment-${candId}`}
                                        value={this.state[`comment-${candId}`]}
                                        rows={4}
                                      />
                                    </div>
                                  </div>
                                </>
                              </AccordionItem>
                            </motion.div>
                          );
                        })}
                      </Accordion>
                    </AnimatePresence>
                  ) : (
                    []
                  )}
                </div>
              </div>
            )}

            {sectionKey === '4' && (
              <div>
                <div className="container mt-4">
                  {/* Desktop View: Grid Layout */}
                  <div className="d-none d-md-flex flex-wrap gap-3 justify-content-center">
                    {_.map(
                      questions?.[0]?.value?.choices,
                      (val, key, index) => {
                        return (
                          <div
                            key={index}
                            className="card shadow-sm p-2"
                            style={{ width: '250px' }}>
                            <Table size="compact">
                              <thead>
                                <tr>
                                  <th className="text-center">Group {key}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {val?.map((itm, idx) => (
                                  <tr key={idx}>
                                    <td className="text-center">
                                      {itm?.fullName}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        );
                      }
                    )}
                  </div>

                  {/* Mobile View: Swiper Carousel */}
                  <div className="d-md-none mt-3">
                    <div className="carousel-container">
                      <SlickSlider {...settings}>
                        {_.map(questions?.[0]?.value?.choices, (val, key) => (
                          <div key={key} className="p-2">
                            <Table size="compact">
                              <thead>
                                <tr>
                                  <th className="text-center">Group {key}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {val?.map((itm, idx) => (
                                  <tr key={idx}>
                                    <td className="text-center">
                                      {itm?.fullName}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ))}
                      </SlickSlider>
                    </div>
                  </div>
                  <div className="mt-5">
                    <Dropdown
                      id="peerCand"
                      title={
                        <div className="cds--type-zeta">
                          Choose one person or select "None" if you do not plan
                          to nominate a Peer
                        </div>
                      }
                      custom
                      mainClassName="mb-0"
                      className="w-50"
                      titleClass="mb-2"
                      labelClass="pt-2 ml-0"
                      onInputChange={() => {}}
                      options={[
                        {
                          label: 'None',
                          value: '0',
                        },
                        ..._.sortBy(
                          _.flatMap(questions, (q) =>
                            _.flatMap(q.value.choices, (group) =>
                              _.map(group, ({ candidateId, fullName }) => ({
                                label: fullName,
                                value: candidateId,
                              }))
                            )
                          ),
                          'label' // sort alphabetically by the label (fullName)
                        ),
                      ]}
                      name="peerCand"
                      placeholder="Peer Candidate"
                      onChange={(value, e, name) =>
                        this.handleDropdownChange(e, name)
                      }
                      selectedValue={peerCand}
                    />
                  </div>
                  {peerCand?.value !== '0' && (
                    <div className="mt-3">
                      <div className="cds--type-zeta mb-2">
                        Comments{' '}
                        {peerCand?.value && (
                          <span className="text-danger">*</span>
                        )}
                      </div>
                      <TextArea
                        className=""
                        key="comments"
                        name="comments"
                        labelText=""
                        hideLabel
                        onChange={(e) =>
                          this.handleChange(e?.target?.name, e?.target?.value)
                        }
                        placeholder="Type Here"
                        // invalid={this.state[`valid-${ratingCriteriaId}`]}
                        // invalidText="Please enter valid answer"
                        id="comments"
                        value={this.state.comments}
                        rows={4}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="fixed-bottom">
              <div className="">
                <Button onClick={() => this.handleSubmit(true)}>
                  Save as Draft
                </Button>
              </div>
              <div className="ml-3 d-flex flex-column align-items-end">
                <div>
                  <Button className="" onClick={() => this.handleSubmit()}>
                    Submit
                  </Button>
                  {/* {!areAllInputsValid && (
                    <div
                      className="mt-2 text-danger"
                      style={{ fontSize: '0.8rem' }}>
                      Please check all fields are filled.
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <JDProcessOverlay show={this.props.loading} message="processing..." />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.PscPeerFeedback.loading,
  assessmentInfo: state.PscPeerFeedback.assessmentInfo,
});

const mapDispatchToProps = {
  getAsessmentInfoByUUID,
  upsertIndvAssSectionResponses,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PscPeerFeedbackAssessment)
);
